export default "__VITE_ASSET__9ecbd4b7__"